import { buildCategoryPageUrl } from '~~/helpers/category/buildCategoryPageUrl';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

export function createOnSaleLink () {

  return '/search?refinementList%5Btags%5D%5B0%5D=on-sale';

}
export function createBestsellingLink () {

  return '/search?refinementList%5Btags%5D%5B0%5D=bestseller';

}
const createCategoryLink = ({
  categorySlug,
  tag,
  countryCode,
}: {
  categorySlug: string;
  tag: string;
  countryCode: CountryCodeValue;
}) => {

  const categoryPath = buildCategoryPageUrl({
    category: categorySlug,
    countryCode,
  });

  return `${categoryPath}?refinementList%5Btags%5D%5B0%5D=${tag}`;

};
export function createCategoryOnSaleLink (categorySlug: string, countryCode: CountryCodeValue) {

  return createCategoryLink({
    categorySlug,
    tag: 'on-sale',
    countryCode,
  });

}
export function createCategoryBestsellersLink (categorySlug: string, countryCode: CountryCodeValue) {

  return createCategoryLink({
    categorySlug,
    tag: 'bestseller',
    countryCode,
  });

}
